import React from 'react';
import { whyChooseUs } from '../data/mock';
import { UserCheck, Sparkles, Clock, IndianRupee, Headphones, Shield, Award } from 'lucide-react';

const iconMap = {
  UserCheck, Sparkles, Clock, IndianRupee, Headphones
};

const WhyChooseUs = () => {
  return (
    <section className="py-16 md:py-24 bg-slate-900 text-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-amber-400 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block px-4 py-1 bg-amber-500/20 text-amber-400 rounded-full text-sm font-medium mb-4">
              Why Choose Us
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Your Comfort & Safety
              <span className="text-amber-400"> is Our Priority</span>
            </h2>
            <p className="text-slate-300 text-lg mb-8">
              With years of experience in the travel industry, we've built our reputation on reliability, safety, and customer satisfaction.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-amber-400">10K+</div>
                <div className="text-sm text-slate-400 mt-1">Happy Customers</div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-amber-400">50+</div>
                <div className="text-sm text-slate-400 mt-1">Vehicles</div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-amber-400">4.9</div>
                <div className="text-sm text-slate-400 mt-1">Rating</div>
              </div>
            </div>
          </div>

          {/* Right Content - Feature Cards */}
          <div className="space-y-4">
            {whyChooseUs.map((item) => {
              const IconComponent = iconMap[item.icon];
              return (
                <div 
                  key={item.id}
                  className="group flex items-center gap-4 p-5 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:bg-white/10 hover:border-amber-500/30 transition-all duration-300"
                >
                  <div className="flex-shrink-0 w-14 h-14 bg-amber-500/20 rounded-xl flex items-center justify-center group-hover:bg-amber-500 transition-colors duration-300">
                    {IconComponent && <IconComponent className="w-7 h-7 text-amber-400 group-hover:text-white transition-colors duration-300" />}
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white group-hover:text-amber-400 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-slate-400 text-sm mt-0.5">
                      {item.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
